import React, { useState, useEffect } from 'react';
import { Cookie, Shield } from 'lucide-react';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already acknowledged the banner
    const hasAcknowledged = sessionStorage.getItem('cookieBannerAcknowledged');
    if (!hasAcknowledged) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    sessionStorage.setItem('cookieBannerAcknowledged', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-blue-600 shadow-2xl z-50 p-4 md:p-6">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex items-start space-x-4">
            <Cookie className="w-8 h-8 text-white flex-shrink-0 mt-1" />
            <div>
              <h3 className="font-semibold text-white text-lg mb-2">
                Welcome to Our Website!
              </h3>
              <p className="text-white text-sm md:text-base leading-relaxed max-w-2xl">
                We value your privacy! This website uses minimal cookies only for essential functionality: 
                maintaining your login session with refresh tokens, and securing your data with end-to-end 
                encryption keys. No tracking, no analytics, no third parties. Just what's needed to keep 
                your account secure.
              </p>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-2 min-w-fit">
            <button
              onClick={handleAccept}
              className="bg-white text-blue-600 px-6 py-3 rounded-full font-semibold hover:bg-blue-50 transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap"
            >
              Got it!
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;